import { render, staticRenderFns } from "./VTooltip.vue?vue&type=template&id=58819f7b&scoped=true"
import script from "./VTooltip.vue?vue&type=script&lang=js"
export * from "./VTooltip.vue?vue&type=script&lang=js"
import style0 from "./VTooltip.vue?vue&type=style&index=0&id=58819f7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58819f7b",
  null
  
)

export default component.exports